/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Rendering_No_EventsInputs */

const en_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering No Selected Events`)
};

const fr_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement selectionne pour le rendu`)
};

const de_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es werden keine ausgewählten Ereignisse gerendert.`)
};

const it_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering di nessun evento selezionato`)
};

const ru_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображение невыбранных событий`)
};

const es_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se representan eventos seleccionados`)
};

const zh_cn2_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未渲染任何选定事件`)
};

const ja_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択されたイベントをレンダリングしません`)
};

const hi_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं के बिना रेंडरिंग`)
};

const pt_pt2_render_audio_rendering_no_events = /** @type {(inputs: Render_Audio_Rendering_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não renderizando nenhum evento selecionado.`)
};

/**
* | output |
* | --- |
* | "Rendering No Selected Events" |
*
* @param {Render_Audio_Rendering_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_no_events = /** @type {((inputs?: Render_Audio_Rendering_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_rendering_no_events(inputs)
	if (locale === "de") return de_render_audio_rendering_no_events(inputs)
	if (locale === "it") return it_render_audio_rendering_no_events(inputs)
	if (locale === "ru") return ru_render_audio_rendering_no_events(inputs)
	if (locale === "es") return es_render_audio_rendering_no_events(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_rendering_no_events(inputs)
	if (locale === "ja") return ja_render_audio_rendering_no_events(inputs)
	if (locale === "hi") return hi_render_audio_rendering_no_events(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_rendering_no_events(inputs)
	return en_render_audio_rendering_no_events(inputs)
});